<script lang="ts">
  let classname = '';
  export { classname as class };
  export let onClick = () => {};
  export let onMouseover = () => {};
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div
  on:click={onClick}
  on:mouseover={onMouseover}
  class={`flex w-full cursor-pointer items-center justify-between rounded-lg px-2 py-2
          text-xs font-medium text-primary-500 hover:bg-surface-500
          ${classname}`}
>
  <slot />
</div>

<style lang="postcss">
</style>
